import React, { useState, useEffect,useMemo  } from "react";

// import "./scrollTable.css";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  FormControl,
  Box,

  CircularProgress,
  InputLabel,
  Button,
} from "@mui/material";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
    Label,
} from 'recharts';
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { PieChart, Pie, Cell } from "recharts";
import { IoIosPeople } from "react-icons/io";
import { PiStudentBold } from "react-icons/pi";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { BsPersonPlusFill } from "react-icons/bs";
import { BsLightningFill } from "react-icons/bs";
import { IoIosCash } from 'react-icons/io';
import { BsFillCreditCardFill } from 'react-icons/bs';
import { MdGroup } from 'react-icons/md';
import { useAuth } from "../../../AuthProvider";
import { GlobalStyles, width } from "@mui/system";

import { BarChart} from 'recharts';
import { useNavigate } from "react-router-dom";

import { useRef } from "react";




const baseUrl=process.env.REACT_APP_API_BASE_URL
const OrganizationDashboard = () => {
const navigate = useNavigate();
const {oId,board,feature}=useAuth();

const [teachersCount, setteachersCount] = useState({});
const [studentCounts, setStudentCounts] = useState({});
const [tuitionFeeAmounts, setTuitionFeeAmounts] = useState({});
const [busFeeAmounts, setBusFeeAmounts] = useState({});

const [dateRange, setDateRange] = useState("currentAcademicYear");


/* ---------- create dummy per-month expense data ---------- */
const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

const basePrincipals = [
  "Principal A",
  "Principal B",
  "Principal C",
  "Principal D",
  "Principal E",
  "Principal F",
];

const cyan = "#00BCD4";

/* helper to build random-ish expenses per month */
function buildMonthlyExpenses() {
  const obj = {};
  months.forEach((month, mIdx) => {
    obj[month] = basePrincipals.map((name, pIdx) => {
      // generate deterministic pseudo-random-ish values
      const raw = 15000 + mIdx * 1200 + pIdx * 4500;
      const jitter = (Math.sin((mIdx + pIdx) * 1.7) + 1) * 2500; // ±2.5k
      const value = Math.round(raw + jitter);
      return { name, value };
    });
  });
  return obj;
}
const allExpenses = buildMonthlyExpenses();

/* ---------- small helpers ---------- */
const kFormatter = (v) => `${(v / 1000).toFixed(1)}K`;
const numberLabel = (v) => `${(v / 1000).toFixed(1)}K`;


 const currentMonth = months[new Date().getMonth()];
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  /* sort ascending so highest expense is last */
const sortedExpensesData = useMemo(() => {
  const list = allExpenses[selectedMonth] || [];
  return [...list].sort((a, b) => a.value - b.value);
}, [selectedMonth]);







  const getLastThreeMonths = (selectedMonth) => {
    const monthOrder = [
      'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
      'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
    ];
   
    const index = monthOrder.indexOf(selectedMonth.toUpperCase());
    const result = [];
 
    for (let i = 2; i >= 0; i--) {
      const monthIndex = (index - i + 12) % 12;
      result.push(monthOrder[monthIndex]);
    }
 
    return result; // Will return in order: [NOVEMBER, DECEMBER, JANUARY] when selectedMonth is JANUARY
  };




const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "5px",
  gap: "15px",
  width: "100%",
};

const cardStyle = {
  flex: 1,
  padding: "5px",
  borderRadius: "10px",
  boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.2s",
  backgroundColor: "#fff",
  borderLeft: "5px solid",
};

const titleStyle = {
  fontWeight: "bold",
  fontSize: "18px",
  marginBottom: "10px",
};

const itemStyle = (borderColor) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px",
  borderRadius: "6px",
  marginBottom: "5px",
  cursor: "pointer",
  fontSize: "14px",
  backgroundColor: "#fff", // Keep background white
  border: `2px solid ${borderColor}`, // Border color added
});

 const iconStyle = (bgColor) => ({
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "8px",
    padding: "3px",
  });




 const cardData = [
  {
    title: "Teachers Overview",
    color: "#007bff",
    items: [
      { label: "TOTAL ", value: teachersCount.total || 0, icon: <PiStudentBold />, path: "/OrgDashTotalTeachersList", bgColor: "#cce5ff" },
      { label: "PRESENT ", value: teachersCount.present|| 0, icon: <BsPersonPlusFill />, path: "/OrgDashPresentTeachersList", bgColor: "#cce5ff" },
      { label: "ABSENT ", value: teachersCount.absent|| 0, icon: <MdGroup />, path: "/OrgDashAbsentTeachersList", bgColor: "#cce5ff" },
    ],
  },
    {
      title: "Students Overview",
      color: "#28a745",
      items: [
        { label: "TOTAL ", value: studentCounts.totalStudents || 0, icon: <PiStudentBold />, path: "/OrgDashTotalStudentsList", bgColor: "#cce5ff" },
        { label: "New ", value: studentCounts.newStudents || 0, icon: <BsPersonPlusFill />, path: "/OrgDashNewStudentsList", bgColor: "#cce5ff" },
        { label: "Existing ", value: studentCounts.existingStudents || 0, icon: <MdGroup />, path: "/OrgDashExistingStudentsList", bgColor: "#c8e6c9" },
      ],
    },
    {
      title: "Tution Fee",
      color: "#4B0082",
      items: [
        { label: "Total", value: `₹${tuitionFeeAmounts.tutionFeePayments || 0}`, icon: <IoIosCash />, path: "/OrgDashTotalTutionFee", bgColor: "#cce5ff" },
        { label: "PAID", value: `₹${tuitionFeeAmounts.tutionFeePaid || 0}`, icon: <BsFillCreditCardFill />, path: `/OrgDashPaidTutionFee?dateRange=${dateRange}`, bgColor: "#d4edda" },
        { label: "UNPAID", value: <span style={{ color: "#DC3545" }}>{`₹${tuitionFeeAmounts.tutionFeeUnPaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/OrgDashUnPaidTutionFee?dateRange=${dateRange}`, bgColor: "#f8d7da" },
      ],
    },
     ...((feature === "CORE" || feature === "ULTRA")? [
    {
      title: "Bus Fee",
      color: "#dc3545",
      items: [
        { label: "Total", value:<span style={{ color: "#28a745" }}>{ `₹${busFeeAmounts.busFeePayments || 0}`}</span>, icon: <IoIosCash />, path: "/OrgDashTotalBusFee", bgColor: "#cce5ff" },
        { label: "PAID", value:<span style={{ color: "#28a745" }}>{ `₹${busFeeAmounts.busFeePaid || 0}`}</span>, icon: <BsFillCreditCardFill />, path: `/OrgDashPaidBusFee?dateRange=${dateRange}`, bgColor: "#d4edda" },
        { label: "UNPAID", value: `₹${busFeeAmounts.busFeeUnPaid || 0}`, icon: <BsFillCreditCardFill />, path: `/OrgDashUnPaidBusFee?dateRange=${dateRange}`, bgColor: "#f8d7da" },
      ],
    },
      ]: []), // Don't include 'Packages' if not ULTRA
  ];




const renderLabel = (entry) => {
  return entry.name;
};

const [tableDate, setTableDate] = useState("today");
const [pieChartDate, setPieChartDate] = useState("today");



const pieData = [
  // { name: "Total Tuition Fee", value: tuitionFeeAmounts.tutionFeePayments  || 0, color: "#EC407A" },
  { name: "Tuition Fee Paid", value: tuitionFeeAmounts.tutionFeePaid || 0, color: "#28a745" },
  { name: "Tuition Fee Unpaid", value:tuitionFeeAmounts.tutionFeeUnPaid   || 0, color: "#DC3545" },
  // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
  // { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#7E57C2" },
  // { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#FF9800" }, // Added a new color for this category
];

// Check if all values are zero to show fallback data
const hasData = pieData.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData = hasData ? pieData : defaultPieData;
const total = finalPieData.reduce((sum, entry) => sum + entry.value, 0);



const pieData1 = [
  // { name: "Total Tuition Fee", value: tuitionFeeAmounts.tutionFeePayments  || 0, color: "#EC407A" },
  // { name: "Tuition Fee Paid", value: tuitionFeeAmounts.tutionFeePaid || 0, color: "#303F9F" },
  // { name: "Tuition Fee Unpaid", value:tuitionFeeAmounts.tutionFeeUnPaid   || 0, color: "#26C6DA" },
  // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
  { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#28a745" },
  { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#DC3545" }, // Added a new color for this category
];

// Check if all values are zero to show fallback data
const hasData1 = pieData1.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData1 = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData1 = hasData1 ? pieData1 : defaultPieData1;
const total1 = finalPieData1.reduce((sum, entry) => sum + entry.value, 0);




//Teachers counts api
useEffect(() => {
  // Fetch data from API
  const fetchData = async () => {
    try {
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

      const response = await fetch(`${baseUrl}/api/attendance/teachers/count/${formattedDate}/${oId}`); // Replace with your API URL
      const data = await response.json();
      setteachersCount(data); // Set the data from API
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  fetchData();
}, []);



//Students counts api
  useEffect(() => {
    const fetchStudentCounts = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/admissionDashBoard/countAllStudentsOrg/${oId}`);
                                               
        if (!response.ok) {
          // throw new Error(`HTTP error! Status: ${response.status}`);
          console.log("Error fetching student data:");
        }
 
        const data = await response.json();
        setStudentCounts(data);
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };
 
    fetchStudentCounts();
  }, [oId]);



  //TutionFeeAmounts api
  const fetchTutionFeeAmounts = async () => {
    try {
      let endpoint = "";
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
 
      switch (dateRange) { // ✅ Changed to 'dateRange'
        case "today":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
        case "yesterday":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllYesterDayTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
        case "lastWeek":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastWeekTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
        case "CurrentMonth":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllThisMonthTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
        case "last6Months":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastSixMonthsTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
        // case "last365Days":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastListPaidInYearTutionPayments/${formattedDate}/tution_fee/${oId}`;
        //   break;
        case "currentAcademicYear":
            endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllCurrentAcademicYearTutionPayments/${formattedDate}/tution_fee/${oId}`;
            break;
        // case "CurrentFinancialYear":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllCurrentFinancialYearTutionPayments/${formattedDate}/tution_fee/${oId}`;
        //   break;
        // case "PreviousFinancialYear":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllPreviousCurrentFinancialYearTutionPayments/${formattedDate}/tution_fee/${oId}`;
        //   break;
        default:
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayTutionPayments/${formattedDate}/tution_fee/${oId}`;
          break;
      }
 
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error("Failed to fetch data");
 
      const data = await response.json();
      setTuitionFeeAmounts(data);
     
    } catch (error) {
      console.error("Error fetching tuition fee amounts:", error);
    }
  };
 
  useEffect(() => {
    fetchTutionFeeAmounts();
  }, [dateRange]);
 


  //BusFeeAmounts api
  const fetchBusFeeAmounts = async () => {
    try {
      let endpoint = "";
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
 
      switch (dateRange) { // ✅ Changed to 'dateRange'
        case "today":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
        case "yesterday":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllYesterdayBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
        case "lastWeek":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastWeekBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
        case "CurrentMonth":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllThisMonthBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
        // case "lastMonth":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}`;
        //   break;
        case "last6Months":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastSixMonthsBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
        // case "last365Days":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllLastListPaidInYearBusPayments/${formattedDate}/bus_fee/${oId}`;
        //   break;
        case "currentAcademicYear":
            endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllCurrentAcademicYearBusPayments/${formattedDate}/bus_fee/${oId}`;
            break;
        // case "CurrentFinancialYear":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllCurrentFinancialYearBusPayments/${formattedDate}/bus_fee/${oId}`;
        //   break;
        // case "PreviousFinancialYear":
        //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllPreviousCurrentFinancialYearBusPayments/${formattedDate}/bus_fee/${oId}`;
        //   break;
        default:
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}`;
          break;
      }
 
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error("Failed to fetch data");
 
      const data = await response.json();
      setBusFeeAmounts(data);
     
    } catch (error) {
      console.error("Error fetching tuition fee amounts:", error);
    }
  };
 
  useEffect(() => {
    fetchBusFeeAmounts();
  }, [dateRange]);



// --------------------------code for Tution Fee garph api-------------------------------------

// -------------- state & data prep --------------
const [tutionFeeGraphData, setTutionFeeGraphData] = useState([]);

useEffect(() => {
  const fetchTutionFeeGraph = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/api/principal/getAllPrincipalsTutionOverAllSchoolData/${oId}`
      );
      if (!res.ok) {
        console.log('Error fetching tuition-fee graph data');
        return;
      }

      const raw = await res.json();

      // ⚙️ 1. shape the data for Recharts ⚙️
      const shaped = raw
        .map((d) => ({
          principal: `${d.firstName} ${d.lastName}`,
          paid: d.paidFeeAmount,
          total: d.assignFeeAmount,
          students: d.totalStudents,
        }))
        // ⚙️ 2. lowest-paid first, highest last ⚙️
        .sort((a, b) => a.paid - b.paid);

      setTutionFeeGraphData(shaped);
    } catch (err) {
      console.error('Error fetching tuition-fee graph data:', err);
    }
  };

  fetchTutionFeeGraph();
}, [oId]);

// -------------- helpers --------------
const rupee = (n) =>
  n.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });



// --------------------------code for Bus Fee garph api-------------------------------------

// ---------- state ----------
const [busFeeGraphData, setBusFeeGraphData] = useState([]);

// ---------- fetch ----------
useEffect(() => {
  const fetchBusFeeGraph = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/api/principal/getAllPrincipalsBusOverAllSchoolData/${oId}`
      );
      if (!res.ok) {
        console.log('Error fetching bus-fee graph data');
        return;
      }

      const raw = await res.json();

      // ---------- shape ----------
      const shaped = raw
        .map((d) => ({
          principal: `${d.firstName} ${d.lastName}`,
          paid: d.paidFeeAmount,
          total: d.assignFeeAmount,
          students: d.totalStudents,
        }))
        .sort((a, b) => a.paid - b.paid); // lowest → highest

      setBusFeeGraphData(shaped);
    } catch (err) {
      console.error('Error fetching bus-fee graph data:', err);
    }
  };

  fetchBusFeeGraph();
}, []);        // no oId dependency for this endpoint








// --------------------------code for EXPENSE  garph api-------------------------------------
// ---------- state ----------
const [expensesGraphData, setExpensesGraphData] = useState([]);

// ---------- fetch ----------
useEffect(() => {
  const fetchExpensesGraph = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/api/principal/getAllPrincipalsExpensesOverAllSchoolData/${oId}`
      );
      if (!res.ok) {
        console.log('Error fetching expenses graph data');
        return;
      }

      const raw = await res.json();

      // ---------- shape ----------
      const shaped = raw
        .map((d) => ({
          principal: `${d.firstName} ${d.lastName}`,
          expense: d.expenseAmount,
        }))
        .sort((a, b) => a.expense - b.expense); // lowest → highest

      setExpensesGraphData(shaped);
    } catch (err) {
      console.error('Error fetching expenses graph data:', err);
    }
  };

  fetchExpensesGraph();
}, []); // no oId dependency here




  return (
    <div style={{ backgroundColor: "#F5F5F6", minHeight: "100vh", padding: "10px" }}>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>

     

     
      {/* Grid for Teachers and Students Stats */}
      <Grid container spacing={1} style={{ marginTop: "5%" }}>


<div style={containerStyle}>
      {cardData.map((card, index) => (
        <div key={index} style={{ ...cardStyle, borderLeftColor: card.color }}>
         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", ...titleStyle }}>
  <div>{card.title}</div>

 
</div>


          {card.items.map((item, idx) => (
            <div
              key={idx}
              style={itemStyle(item.bgColor)} // Apply border color from bgColor
              onClick={() => navigate(item.path)}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#e8f0fe";
                // e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#f9f9f9";
                // e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={iconStyle(item.bgColor)}>{item.icon}</div>
                <span style={{ fontWeight: "bold" }}>{item.label}</span>
              </div>
              <span style={{ fontWeight: "bold", color: card.color }}>{item.value}</span>
            </div>
          ))}
        </div>
      ))}
    </div>

</Grid>




{/* Tution fee Graph and pie chart  code*/}

      <div style={{ display: "flex", marginTop: "px", paddingTop: "5px", justifyContent: "space-between" }}>
         {/* Card containing table title, date selector, and table */}

{/* 
 // -------------- graph --------------// */}
<div
  style={{
    flex: 2.5,
    padding: 5,
    background: '#fff',
    borderRadius: 8,
    marginRight: 5,
    minHeight: 300,
    display: 'flex',
    flexDirection: 'column',
  }}
>
  <Typography
    variant="h6"
    sx={{ fontWeight: 'bold', pl: 2, mt: 1, mb: 1, color: '#333', textAlign: 'left' }}
  >
    Tuition Fee Revenue (per Principal)
  </Typography>

  {tutionFeeGraphData.length === 0 ? (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 500,
        color: '#999',
      }}
    >
      No data available
    </div>
  ) : (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={tutionFeeGraphData}
        margin={{ top: 20, right: 30, left: 20, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="principal" />
        <YAxis tickFormatter={rupee} />
        <Tooltip
          content={({ active, payload, label }) => {
            if (!active || !payload?.length) return null;
            const d = payload[0].payload;
            return (
              <Paper sx={{ p: 1 }}>
                <Typography variant="subtitle2" fontWeight={700}>
                  {label}
                </Typography>
                <Typography variant="body2">Total Amount: {rupee(d.total)}</Typography>
                <Typography variant="body2">Paid Amount: {rupee(d.paid)}</Typography>
                <Typography variant="body2">Students: {d.students}</Typography>
              </Paper>
            );
          }}
        />
        <Legend />

        <Bar
          dataKey="paid"
          name="Paid Amount"
          fill="#06b6d4"
          barSize={45}
          radius={[3, 3, 0, 0]}
        >
          <LabelList
            dataKey="paid"
            position="insideTop"
            formatter={rupee}
            style={{ fill: '#fff', fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )}
</div>







{/* pie chart  for SchoolFee*/}
<div
  style={{
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  }}
>
  <div style={{ position: "relative", width: "100%" }}>
    {/* Dropdown (Date Range) */}
    <FormControl
      variant="outlined"
      size="small"
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 1,
        width: "120px",
        height: "30px",
      }}
    >
      <InputLabel>Select Range</InputLabel>
      <Select
        value={dateRange}
        onChange={(e) => setDateRange(e.target.value)}
        label="Select Range"
        style={{ height: "30px", fontSize: "12px" }}
      >
        <MenuItem value="today">Today</MenuItem>
        <MenuItem value="yesterday">Yesterday</MenuItem>
        <MenuItem value="lastWeek">Last Week</MenuItem>
        <MenuItem value="CurrentMonth">Current Month</MenuItem>
        <MenuItem value="last6Months">Last 6 Months</MenuItem>
        <MenuItem value="currentAcademicYear">Current Academic Year</MenuItem>
      </Select>
    </FormControl>

    {/* Table Container */}
    <TableContainer
      component={Paper}
      style={{
        height: "380px",
        width: "100%",
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        paddingTop: "1px",
        boxShadow: "none",
        border: "none",
      }}
    >
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "left",
          paddingLeft: "15px",
          marginBottom: "10px",
          marginTop: "10px",
          color: "#333",
        }}
      >
        School Fee Payments
      </Typography>



<Table style={{ border: "none" }}>
  <TableBody>
    <TableRow>
      <TableCell
        style={{
          padding: 0,
          height: "100%",
          borderBottom: "none",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: "5px",
            paddingBottom: "5px",
          }}
        >
          {/* Chart or No Data Message */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              width: "280px",
              height: "280px",
            }}
          >
            {hasData ? (
              <ResponsiveContainer width={270} height={280}>
                <PieChart>
                  <Pie
                    data={finalPieData}
                    cx="50%"
                    cy="50%"
                    innerRadius={35}
                    outerRadius={80}
                    paddingAngle={3}
                    dataKey="value"
                   label={({ value }) => {
        const percent = total === 0 ? 0 : (value / total) * 100;
        return `${percent.toFixed(1)}%`;
      }}

                  >
                    {finalPieData.map((entry, index) => (
                      // <Cell key={index} fill={entry.color} />
                       <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <Typography
                variant="body2"
                style={{
                  color: "#888",
                  fontSize: "14px",
                  fontWeight: 900,
                }}
              >
                No data available
              </Typography>
            )}
          </div>

          {/* Bottom Labels */}
          {hasData && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginTop: "1px",
                paddingBottom: "5px",
              }}
            >
              {pieData.map((entry, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "3px 8px",
                  }}
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: entry.color,
                      marginRight: "4px",
                    }}
                  ></div>
                  <Typography
                    variant="body2"
                    style={{
                      color: "#333",
                      fontWeight: "bold",
                      fontSize: "11px",
                    }}
                  >
                    {entry.name}
                  </Typography>
                </div>
              ))}
            </div>
          )}
        </div>
      </TableCell>
    </TableRow>
  </TableBody>
</Table>


    </TableContainer>
  </div>
</div>




      </div>

     
{/* Bus fee Revenue Graph and pie chart  code*/}
{(feature === "CORE" || feature === "ULTRA") &&(
<     div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>

         {/* Bus fee Revenue Graph*/}

<div
  style={{
    flex: 2.5,
    padding: 5,
    background: '#fff',
    borderRadius: 8,
    marginRight: 5,
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 'bold',
      pl: 2,
      mt: 1,
      mb: 1,
      color: '#333',
      textAlign: 'left',
    }}
  >
    Bus Fee Revenue (per Principal)
  </Typography>

  {busFeeGraphData.length === 0 ? (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 500,
        color: '#999',
      }}
    >
      No data available
    </div>
  ) : (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        data={busFeeGraphData}
        margin={{ top: 20, right: 30, left: 20, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="principal" />
        <YAxis tickFormatter={rupee} />
        <Tooltip
          content={({ active, payload, label }) => {
            if (!active || !payload?.length) return null;
            const d = payload[0].payload;
            return (
              <Paper sx={{ p: 1 }}>
                <Typography variant="subtitle2" fontWeight={700}>
                  {label}
                </Typography>
                <Typography variant="body2">Total Amount: {rupee(d.total)}</Typography>
                <Typography variant="body2">Paid Amount: {rupee(d.paid)}</Typography>
                <Typography variant="body2">Students: {d.students}</Typography>
              </Paper>
            );
          }}
        />
        <Legend />

        <Bar
          dataKey="paid"
          name="Paid Amount"
          fill="#06b6d4"
          barSize={45}
          radius={[3, 3, 0, 0]}
        >
          <LabelList
            dataKey="paid"
            position="insideTop"
            formatter={rupee}
            style={{ fill: '#fff', fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )}
</div>



{/* pie chart for BusFee*/}
<div
  style={{
    flex: 1,
    marginLeft: "1px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  }}
>
  <div style={{ position: "relative", width: "100%" }}>
      


      <TableContainer
  style={{
    height: "250px", // Reduced height from full to 250px
    width: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    paddingTop: "20px",
    boxShadow: "none",
    border: "none",
  }}
>

      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "left",
          marginTop: "0px", // Added top margin for spacing
          paddingLeft: "30px", // Added left padding
          marginBottom: "10px",
          color: "#333",
        }}
      >
        BusFee Payments
      </Typography>

      <Table style={{ border: "none" }} >
        <TableBody>
          <TableRow>
            <TableCell
                    style={{
                    padding: 0,
                    height: "100%",
                    borderBottom: "none",
                    textAlign: "center",
                    }} >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Pie Chart */}
               <div
                                                   style={{
                                                     position: "relative",
                                                     display: "flex",
                                                     flexDirection: "column",
                                                     alignItems: "center",
                                                     marginTop: "-25px",
                                                     // backgroundColor: "#fff",
                                                     // padding: "5px",
                                                     // borderRadius: "8px",
                                                     // boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                                                   }}
                                                 >
                                                   {/* Pie Chart */}
                                                 <ResponsiveContainer width={210} height={210}>
  <PieChart>
    <Pie
      data={finalPieData1}
      cx="50%"
      cy="50%"
      innerRadius={23}
      outerRadius={50}
      paddingAngle={2}
      dataKey="value"
      label={({ value }) => {
        const percent = total1 === 0 ? 0 : (value / total1) * 100;
        return `${percent.toFixed(1)}%`;
      }}
      
    >
      {finalPieData1.map((entry, index) => (
        <Cell key={index} fill={entry.color} />
      ))}
    </Pie>
    <Tooltip />
  </PieChart>
</ResponsiveContainer>
                             
                                                   {/* Center Text */}
                                                   {/* <div
                                                     style={{
                                                       position: "absolute",
                                                       top: "50%",
                                                       left: "50%",
                                                       transform: "translate(-50%, -50%)",
                                                       textAlign: "center",
                                                       fontWeight: "bold",
                                                       fontSize: "14px",
                                                     }}
                                                   >
                                                     <p>95.67%</p>
                                                     <p style={{ fontSize: "12px", color: "#666" }}>
                                                       OVERALL
                                                     </p>
                                                   </div> */}
                               </div>

                {/* Labels on the right side of the pie chart */}
                <div
                                                    style={{
                                                      paddingLeft: "15px",
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      justifyContent: "center",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    {pieData1.map((entry, index) => (
                                                      <div
                                                        key={index}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          marginBottom: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "12px",
                                                            height: "12px",
                                                            backgroundColor: entry.color,
                                                            marginRight: "8px",
                                                          }}
                                                        ></div>
                                                        <Typography
                                                          variant="body2"
                                                          style={{
                                                            color: "#333",
                                                            fontWeight: "bold",
                                                            fontSize: "11px",
                                                          }}
                                                        >
                                                          {entry.name}
                                                        </Typography>
                                                      </div>
                                                    ))}
                                                  </div>

              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </div>
        </div>


      </div>
)}


{/* Notice Board and Expenses */}

                   <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between", height: "400px" }}>    
                                                             
                                       
                                                      
                                       
                                       
                                       
                                                      {/* Expenses bar chart */}
                                       
 <div
  style={{
    flex: 2.5,
    padding: 5,
    background: '#fff',
    borderRadius: 8,
    marginRight: 5,
    minHeight: 300,
    display: 'flex',
    flexDirection: 'column',
  }}
>
  <Typography
    variant="h6"
    sx={{ fontWeight: 'bold', pl: 2, mt: 1, mb: 1, color: '#333', textAlign: 'left' }}
  >
    Expenses (per Principal)
  </Typography>

  {expensesGraphData.length === 0 ? (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 500,
        color: '#999',
      }}
    >
      No data available
    </div>
  ) : (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={expensesGraphData}
        margin={{ top: 20, right: 30, left: 20, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="principal" />
        <YAxis tickFormatter={rupee} />
        <Tooltip
          formatter={(v) => rupee(v)}
          labelFormatter={(l) => `Principal: ${l}`}
        />
        <Legend />

        <Bar
          dataKey="expense"
          name="Expense Amount"
          fill="#06b6d4"
          barSize={45}
          radius={[3, 3, 0, 0]}
        >
          <LabelList
            dataKey="expense"
            position="insideTop"
            formatter={rupee}
            style={{ fill: '#fff', fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )}
</div>


                                       
                                       
                                       
                   </div>

    </div>
  );
};




export default OrganizationDashboard;